module.exports = require('./helpers/bundle-url').getBundleURL('jKRPl') + "elationemr-logo.b383e863.png";